import angular from 'angular';
import {HeaderComponent} from './header.component.js';

const header = angular.module('header', []);

header.component('header', HeaderComponent);

export {header};



// WEBPACK FOOTER //
// ./app/components/common/header/header.js